import React, { useEffect, useRef, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchOrders } from '../../../../actions/order/orderList'
import { Orders } from '../../Orders'
import Order from '../../../../models/Order'
import { AppState } from '../../../../reducers'
import { OrderListState } from '../../../../reducers/order/orderList'
import { Filters, FiltersBar, defaultFilters } from '../../../Utils/Filters/Filter'
import { FilterFromDate, FilterToDate, FilterNumber, FilterStatusOrder, FilterClientName } from '../../../Utils/Filters'
import { useTranslation } from 'react-i18next'
import { PERSON } from '../../../../models/User'
import { roleToURLPrefix } from '../../../../App'
import { SessionState, isAdmin, isClient, isHeadSales, isManager, isStaff } from '../../../../reducers/auth/session'
import { Stack } from '@mui/material'
import Preorders from '../../Preorders'
import { PreorderCtrlListState } from '../../../../reducers/preorder/preorderCtrlList'
import Preorder from '../../../../models/Preorder'
import { fetchCtrlPreorders } from '../../../../actions/preorder/preorderCtrlList'
import moment from 'moment'

interface Props {
  fullInfo?: boolean
  orderList: OrderListState
  preorderCtrlList?: PreorderCtrlListState
  session: SessionState
}

const OrderList: React.FC<Props> = ({ orderList, preorderCtrlList, session, fullInfo = true }) => {
  const [page, setPage] = useState<number>(0)
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('order')
  const lastOrdersSearchRef = useRef<string>('')

  useEffect(() => {
    dispatch({ type: 'ORDER_CLEAR' })
    // eslint-disable-next-line react-hooks/exhaustive-deps        
  }, [])

  useEffect(() => {
    const search = !fullInfo
      ? '?status=Ingresado,En+Preparación,En+Distribución,Para+retirar,Entregado+(Con+Pendientes)'
      : history.location.search
        ? `${history.location.search}&limit=25`
        : `?limit=25`

    if (lastOrdersSearchRef.current === search) {
      return
    }

    lastOrdersSearchRef.current = search
    dispatch(fetchOrders(search))
  }, [dispatch, history.location.search, fullInfo])

  useEffect(() => {
    if (fullInfo) {
      dispatch(fetchCtrlPreorders(`?statusPO=A,P,H,D,R&limit=5${page ? `&page=${page}` : ''}`))
    }
  }, [dispatch, fullInfo, page])


  const linkToOrderDetail = (order: Order) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/orders/detail/${order.id_pedido}`
    history.push(detailUrl)
  }

  const linkToPreorderDetail = (preorder: Preorder) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/preorders/detail/${preorder.id}`
    history.push(detailUrl)
  }


  const initDefaultFilters: Filters = {
    ...defaultFilters,
    from: moment().startOf('month').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
  }

  return (
    <Stack style={{ height: fullInfo ? 'calc(100% - var(--header-height)' : '' }}>
      {fullInfo && preorderCtrlList && isClient(session) &&
        <Preorders
          rows={(preorderCtrlList.preorders || []).filter(s => s.status !== 'C').map(s => ({ data: s }))}
          loading={preorderCtrlList.isFetching!}
          pagination={preorderCtrlList.pagination || { size: 5 }}
          onClickInfo={linkToPreorderDetail}
          onChangePage={setPage}
        />}
      {fullInfo &&
        <FiltersBar defaultFilters={initDefaultFilters}>
          <FilterFromDate label={t("fromDate")} />
          <FilterToDate label={t("toDate")} />
          {/*<FilterStatusOrder name='estado' label={t("status")} onChange={(name: string, value: any) => { setEstadosList(value.map(v => v.toLowerCase())) }} />*/}
          <FilterStatusOrder label={t("status")} />
          <FilterNumber name="orderNumber" label={t("number")} />
          {(isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)) ? <FilterClientName name="codigo_cliente" label={t('title', { ns: 'client' })} /> : <></>}
        </FiltersBar>}
      <Orders
        rows={(orderList.orders || []).map(s => ({ data: s }))}
        loading={orderList.isFetching}
        pagination={orderList.pagination || undefined}
        fullInfo={fullInfo}
        adminInfo={isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)}
        onClickInfo={linkToOrderDetail}
        isChaco={session.isChaco}
      />
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  orderList: state.orderList,
  preorderCtrlList: state.preorderCtrlList,
  session: state.session
})

export default connect(mapStateToProps, null)(OrderList)